import { Helpers } from '../../helpers';
import { IConstraintFacilityTruck } from '../../interfaces/iconstraint-facility-truck';
import { AreaType } from '../area-type';
import { ConstraintFacilityTruckDetail } from '../constraint-facility-truck-detail';
import { Scenario } from '../scenario';

export class ConstraintFacilityTruckBase {
  ConstraintFacilityTruckId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintFacilityTruckDetails_ConstraintFacilityTruck?: Array<ConstraintFacilityTruckDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintFacilityTruck) {
    if (item) {

      this.ConstraintFacilityTruckId = item.ConstraintFacilityTruckId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintFacilityTruckDetails_ConstraintFacilityTruck = Helpers.createClassArray(ConstraintFacilityTruckDetail, item.ConstraintFacilityTruckDetails_ConstraintFacilityTruck);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}